<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-id-card"></i></div>
      <div>
        Détail de l'inscription
        <div class="page-title-subheading">Dossier complet d'un élève inscrit</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

    <div class="row">
      <div class="col-12 col-md-8 mx-auto">
        <div class="card mb-3"> 
          <div class="card-header">
              <div class="d-flex justify-content-between">
                  <div class="card-title">Information sur l'élève </div>
              
                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Rechercher..." [(ngModel)]="search_text">
                    </div>
                </div>
          </div>
          <div class="card-body">
              <div class="row">
                  <dl class="col-12 col-md-6">
                      <dt><b>Code</b></dt>
                      <dd>{{data?.student?.code}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                      <dt><b>Nom</b></dt>
                      <dd>{{data?.student?.lastname}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                      <dt><b>Prénom(s)</b></dt>
                      <dd>{{data?.student?.firstname}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                      <dt><b>Date de naissance</b></dt>
                      <dd>{{data?.student?.birthdate | date:"dd-MM-yyyy"}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Lieu de naissance</b></dt>
                    <dd>{{data?.student?.birthplace}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Adresse</b></dt>
                  <dd>{{data?.student?.address}}</dd>
              </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Sexe</b></dt>
                  <dd>{{data?.student?.sex}}</dd>
              </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Observation</b></dt>
                  <dd>{{data?.student?.observation}}</dd>
              </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Nationalité</b></dt>
                <dd>{{data?.student?.origin}}</dd>
            </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Langue(s) parlée(s)</b></dt>
                  <dd>{{data?.student?.languages}}</dd>
              </dl>
              <dl class="col-12">
                <dt><b>Classe d'inscription</b></dt>
                <dd>{{data?.student?.current_ay_classroom?.classroom?.name}}</dd>
            </dl>
                  
            <div class="text-center">
              <button class="btn btn-sm btn-warning" (click)="open(editContent4,data.student)">Modifier</button>
            </div>
              </div>
          </div>
      </div>
      </div>
      <div class="col-12 col-md-8 mx-auto">
        <div class="card mb-3"> 
          <div class="card-header">
              <div class="d-flex justify-content-between">
                  <div class="card-title">Information sur la scolarité de l'enfant </div>
              </div>
          </div>
          <div class="card-body">
             <table class="table table-sm">
              <thead>
                <th>#</th>
                <th>Année scolaire</th>
                <th>Classe</th>
                <th>Nom de l'établissement</th>
                <th>Système</th>
                <th>Pays</th>
                <th>Action</th>
              </thead>
              <tbody>
                <tr *ngFor="let od of data?.old_schools; let i=index">
                  <td>{{i+1}}</td>
                  <td>{{od.academic_year}}</td>
                  <td>{{od.classroom}}</td>
                  <td>{{od.school_name}}</td>
                  <td>{{od.system}}</td>
                  <td>{{od.country}}</td>
                  <button  class="btn btn-sm btn-warning" (click)="open(editContent,od)"><i class="fa fa-edit"></i></button>
                  <button class="btn btn-sm btn-danger" (click)="deleteSchool(od.id)"><i class="fa fa-edit"></i></button>
                </tr>
              </tbody>
             </table>
          </div>
      </div>
      </div>
      <div class="col-12 col-md-8 mx-auto">
        <div class="card mb-3"> 
          <div class="card-header">
              <div class="d-flex justify-content-between">
                  <div class="card-title">Information sur les frères et soeurs de l'enfant </div>
              </div>
          </div>
          <div class="card-body">
             <table class="table table-sm">
              <thead>
                <th>#</th>
                <th>Identité</th>
                <th>Date de naissance</th>
                <th>Classe</th>
                <th>Etablissement</th>
                <th>Action</th>
              </thead>
              <tbody>
                <tr *ngFor="let od of data?.student?.parent?.families; let i=index">
                  <td>{{i+1}}</td>
                  <td>{{od.identity}}</td>
                  <td>{{od.birthdate | date:"dd-MM-yyyy"}}</td>
                  <td>{{od.classroom}}</td>
                  <td>{{od.school}}</td>
                  <td>
                    <button  class="btn btn-sm btn-warning" (click)="open(editContent,od)"><i class="fa fa-edit"></i></button>
                    <button class="btn btn-sm btn-danger" (click)="deleteFamily(od.id)"><i class="fa fa-edit"></i></button>
                  </td>
                </tr>
              </tbody>
             </table>
          </div>
      </div>
      </div>
      <div class="col-12 col-md-8 mx-auto">
        <div class="card mb-3"> 
          <div class="card-header">
              <div class="d-flex justify-content-between">
                  <div class="card-title">Information sur les parents l'enfant </div>
              </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6">
                <h6>Père</h6>
                <div class="row">
                  <dl class="col-12 col-md-6">
                    <dt><b>Code</b></dt>
                    <dd>{{data?.student?.parent?.code}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Nom</b></dt>
                    <dd>{{data?.student?.parent?.father_lastname}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Prénom(s)</b></dt>
                    <dd>{{data?.student?.parent?.father_firstname}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Email</b></dt>
                    <dd>{{data?.student?.parent?.father_email}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Contact</b></dt>
                    <dd>{{data?.student?.parent?.father_phone}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Profession</b></dt>
                    <dd>{{data?.student?.parent?.father_job}}</dd>
                  </dl>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <h6>Mère</h6>
                <div class="row">
                  <dl class="col-12 col-md-6">
                    <dt><b>Code</b></dt>
                    <dd>{{data?.student?.parent?.code}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Nom</b></dt>
                    <dd>{{data?.student?.parent?.mother_lastname}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Prénom(s)</b></dt>
                    <dd>{{data?.student?.parent?.mother_firstname}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Email</b></dt>
                    <dd>{{data?.student?.parent?.mother_email}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Contact</b></dt>
                    <dd>{{data?.student?.parent?.mother_phone}}</dd>
                  </dl>
                  <dl class="col-12 col-md-6">
                    <dt><b>Profession</b></dt>
                    <dd>{{data?.student?.parent?.mother_job}}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="text-center">
              <button class="btn btn-sm btn-warning" (click)="open(editContent3,data.student?.parent)">Modifier</button>
            </div>
          </div>
      </div>
      </div>
      <div class="col-12 col-md-8 mx-auto">
        <div class="card mb-3"> 
          <div class="card-header">
              <div class="d-flex justify-content-between">
                  <div class="card-title">Personne à contacter en cas d'urgence </div>
              </div>
          </div>
          <div class="card-body">
            <div class="row">
              <dl class="col-12 col-md-6">
                <dt><b>Nom</b></dt>
                <dd>{{data?.student?.parent?.tutor_lastname}}</dd>
              </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Prénom(s)</b></dt>
                <dd>{{data?.student?.parent?.tutor_firstname}}</dd>
              </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Email</b></dt>
                <dd>{{data?.student?.parent?.tutor_email}}</dd>
              </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Contact</b></dt>
                <dd>{{data?.student?.parent?.tutor_phone}}</dd>
              </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Profession</b></dt>
                <dd>{{data?.student?.parent?.tutor_job}}</dd>
              </dl>
            </div>
            <div class="text-center">
              <button class="btn btn-sm btn-warning" (click)="open(editContent5,data.student?.parent)">Modifier</button>
            </div>
          </div>
      </div>
      </div>
      <div class="col-12 col-md-8 mx-auto">
        <div class="card mb-3" *ngIf="data != undefined"> 
          <div class="card-header">
              <h6 class="card-title">Document d'inscription</h6>
          </div>
          <div class="card-body">
              <ol>
                 <li *ngFor="let r of data?.files" > <i class="fa fa-eye mr-1"></i> <a  class="text-primary text-underline" (click)="getFile(data?.code,'inscription',r.pivot?.filename)" style="cursor: pointer;">{{r.document?.name}}</a></li>
  
              </ol>
          </div>
      </div>
      </div>
    </div>


    <ng-template #contentPDF let-offcanvas>
      <div class="offcanvas-header">
        
        <h4 class="offcanvas-title">Visualiseur de fichier</h4>
        <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
      </div>
      <div class="offcanvas-body">
            <ngx-extended-pdf-viewer [src]="pdfSrc"
            style="width: 100%; height: 100%"
            ></ngx-extended-pdf-viewer>
      </div>
    </ng-template>

    <ng-template #editContent let-c="close" let-d="dismiss">
      <form #addForm="ngForm" (ngSubmit)="editSchool(addForm)">
      <div class="modal-header">
        <h6 class="modal-title" id="modal-basic-title">Renseigner les champs</h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>
      <div class="modal-body" >
          <div class="row mb-3" >
        
              <div class=" form-group col-12 mb-3">
                  <label for="">Année scolaire <span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="academic_year" class="form-control" [(ngModel)]="selected_data.academic_year">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Classe fréquentée <span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="classroom" class="form-control" [(ngModel)]="selected_data.classroom">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Nom del'établissement <span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="school_name" class="form-control" [(ngModel)]="selected_data.school_name">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Pays <span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="country" class="form-control" [(ngModel)]="selected_data.country">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Système éducatif <span class="text-danger ml-2">(*)</span></label>
                  <select name="system" class="form-control" [(ngModel)]="selected_data.system">
                      <option value="Local">Local</option>
                      <option value="Français">Français</option>
                      <option value="Autre">Autre</option>
                  </select>
              </div>
              <div *ngIf="selected_data.system=='Autre'" class=" form-group col-12 mb-3">
                  <label for="">Précision du système éducatif <span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="country" class="form-control" [(ngModel)]="selected_data.system_precision">
              </div>
          </div>
         
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
      </div>
  </form>
    </ng-template>
  


    <ng-template #editContent2 let-c="close" let-d="dismiss">
      <form #addForm="ngForm" (ngSubmit)="editFamily(addForm)">
      <div class="modal-header">
        <h6 class="modal-title" id="modal-basic-title">Modifier les données</h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>
      <div class="modal-body" >
          <div class="row mb-3" >
        
              <div class=" form-group col-12 mb-3">
                  <label for="">Nom et prénom(s)<span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="identity" class="form-control" [(ngModel)]="selected_data.identity">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                  <input type="date" name="birthdate" class="form-control" [(ngModel)]="selected_data.birthdate">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Classe actuelle <span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="classroom" class="form-control" [(ngModel)]="selected_data.classroom">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Etablissement actuellement fréquentée <span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="school" class="form-control" [(ngModel)]="selected_data.school">
              </div>
              
          </div>
         
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
      </div>
  </form>
    </ng-template>
    <ng-template #editContent3 let-c="close" let-d="dismiss">
      <form #addForm="ngForm" (ngSubmit)="editParent(addForm)">
      <div class="modal-header">
        <h6 class="modal-title" id="modal-basic-title">Modifier les données</h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>
      <div class="modal-body" >
         <fieldset>
          <legend>Information du père</legend>
          <div class="row mb-3" >
        
            <div class=" form-group col-12 mb-3">
                <label for="">Nom<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="father_lastname" class="form-control" [(ngModel)]="selected_data.father_lastname">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Prénom(s)<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="father_firstname" class="form-control" [(ngModel)]="selected_data.father_firstname">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Profession<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="father_job" class="form-control" [(ngModel)]="selected_data.father_job">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Email<span class="text-danger ml-2">(*)</span></label>
                <input type="email" name="father_email" class="form-control" [(ngModel)]="selected_data.father_email">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Contact<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="father_phone" class="form-control" [(ngModel)]="selected_data.father_phone">
            </div>

        </div>
         </fieldset>
         <fieldset>
          <legend>Information de la mère</legend>
          <div class="row mb-3" >
        
            <div class=" form-group col-12 mb-3">
                <label for="">Nom<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="mother_lastname" class="form-control" [(ngModel)]="selected_data.mother_lastname">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Prénom(s)<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="mother_firstname" class="form-control" [(ngModel)]="selected_data.mother_firstname">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Profession<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="mother_job" class="form-control" [(ngModel)]="selected_data.mother_job">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Email<span class="text-danger ml-2">(*)</span></label>
                <input type="email" name="mother_email" class="form-control" [(ngModel)]="selected_data.mother_email">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Contact<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="mother_phone" class="form-control" [(ngModel)]="selected_data.mother_phone">
            </div>

        </div>
         </fieldset>
         
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
      </div>
  </form>
    </ng-template>
    <ng-template #editContent4 let-c="close" let-d="dismiss">
      <form #addForm="ngForm" (ngSubmit)="editStudent(addForm)">
      <div class="modal-header">
        <h6 class="modal-title" id="modal-basic-title">Modifier les données</h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>
      <div class="modal-body" >
          <div class="row mb-3" >
        
              <div class=" form-group col-12 mb-3">
                  <label for="">Nom<span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="lastname" class="form-control" [(ngModel)]="selected_data.lastname">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Prénom(s)<span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="firstname" class="form-control" [(ngModel)]="selected_data.firstname">
              </div>
              <div class=" form-group col-12 mb-3">
                <label for="">Sexe<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="sex" class="form-control" [(ngModel)]="selected_data.sex">
            </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                  <input type="date" name="birthdate" class="form-control" [(ngModel)]="selected_data.birthdate">
              </div>
              <div class=" form-group col-12 mb-3">
                  <label for="">Lieu de naissance<span class="text-danger ml-2">(*)</span></label>
                  <input type="text" name="birthplace" class="form-control" [(ngModel)]="selected_data.birthplace">
              </div>
              <div class=" form-group col-12 mb-3">
                <label for="">Nationalité<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="origin" class="form-control" [(ngModel)]="selected_data.origin">
            </div>
            <div class=" form-group col-12 mb-3">
              <label for="">Langue(s) parlée(s)<span class="text-danger ml-2">(*)</span></label>
              <input type="text" name="languages" class="form-control" [(ngModel)]="selected_data.languages">
          </div>
          <div class=" form-group col-12 mb-3">
            <label for="">Email<span class="text-danger ml-2">(*)</span></label>
            <input type="email" name="email" class="form-control" [(ngModel)]="selected_data.email">
        </div>
            
              
          <div class=" form-group col-12 mb-3">
            <label for="">Observation<span class="text-danger ml-2">(*)</span></label>
            <textarea class="form-control"  name="observation" [(ngModel)]="selected_data.observation"></textarea>
        </div>
            
              
    
            
              
          </div>
         
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
      </div>
  </form>
    </ng-template>
    <ng-template #editContent5 let-c="close" let-d="dismiss">
      <form #addForm="ngForm" (ngSubmit)="editParent(addForm)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Modifier les données</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
          <div class="row mb-3" >
          
            <div class=" form-group col-12 mb-3">
                <label for="">Nom<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="tutor_lastname" class="form-control" [(ngModel)]="selected_data.tutor_lastname">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Prénom(s)<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="tutor_firstname" class="form-control" [(ngModel)]="selected_data.tutor_firstname">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Profession<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="tutor_job" class="form-control" [(ngModel)]="selected_data.tutor_job">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Email<span class="text-danger ml-2">(*)</span></label>
                <input type="email" name="tutor_email" class="form-control" [(ngModel)]="selected_data.tutor_email">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Contact<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="tutor_phone" class="form-control" [(ngModel)]="selected_data.tutor_phone">
            </div>

        </div>
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
    </ng-template>